import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.position, position = _b === void 0 ? 'top' : _b;
    var _c = useState(false), isVisible = _c[0], setIsVisible = _c[1];
    var _d = useState(position), autoPosition = _d[0], setAutoPosition = _d[1];
    var containerRef = useRef(null);
    var tooltipRef = useRef(null);
    useEffect(function () {
        if (isVisible && containerRef.current && tooltipRef.current) {
            var container = containerRef.current.getBoundingClientRect();
            var tooltip = tooltipRef.current.getBoundingClientRect();
            var space = {
                top: container.top - tooltip.height,
                right: window.innerWidth - (container.right + tooltip.width),
                bottom: window.innerHeight - (container.bottom + tooltip.height),
                left: container.left - tooltip.width
            };
            var bestPosition_1 = 'top';
            var maxSpace_1 = space.top;
            Object.entries(space).forEach(function (_a) {
                var pos = _a[0], amount = _a[1];
                if (amount > maxSpace_1) {
                    maxSpace_1 = amount;
                    bestPosition_1 = pos;
                }
            });
            setAutoPosition(bestPosition_1);
        }
    }, [isVisible]);
    return (React.createElement("div", { ref: containerRef, className: "talkbot-tooltip-wrap", onMouseEnter: function () { return setIsVisible(true); }, onMouseLeave: function () { return setIsVisible(false); } },
        children,
        React.createElement(AnimatePresence, null, isVisible && (React.createElement(motion.div, { ref: tooltipRef, initial: { opacity: 0, scale: 0.9 }, animate: { opacity: 1, scale: 1 }, exit: { opacity: 0, scale: 0.9 }, className: "talkbot-tooltip talkbot-tooltip--".concat(autoPosition) }, content)))));
};
export default Tooltip;
